<main class="container-fluid finance-console">
  <header class="finance-page-header d-flex justify-content-between align-items-start flex-wrap gap-2 mb-4">
    <div>
      <h3 class="page-title mb-1 mt-0">{{ 'AMAZON_FINANCE_TITLE' | translate }}</h3>
      <p class="text-muted mb-0">{{ 'AMAZON_FINANCE_SUBTITLE' | translate }}</p>
    </div>
    <button type="button" class="btn btn-primary btn-sm refresh-button" (click)="loadDashboard()" [disabled]="loading">
      <i class="fa-solid fa-rotate" [class.fa-spin]="loading"></i>
      {{ 'REFRESH' | translate }}
    </button>
  </header>

  <nav class="finance-navigation" aria-label="Amazon finance sections">
    @for (section of sections; track section.id) {
      <button
        type="button"
        class="finance-navigation__item"
        [class.active]="activeSection === section.id"
        (click)="selectSection(section.id)"
      >
        <i class="fa-solid" [ngClass]="section.icon"></i>
        {{ section.label | translate }}
      </button>
    }
  </nav>

  @if (error) {
    <div class="alert alert-danger mt-3">{{ error | translate }}</div>
  }

  @if (activeSection === 'overview') {
    <section class="overview-section" aria-live="polite">
      @if (loading && !dashboard) {
        <div class="finance-loading"><span class="spinner-border"></span></div>
      } @else if (dashboard) {
        <div class="kpi-grid">
          <button type="button" class="kpi-card kpi-card--neutral" (click)="openTransactions()">
            <span>{{ 'TOTAL_TRANSACTIONS' | translate }}</span>
            <strong>{{ dashboard.totalTransactions | number }}</strong>
            <small>{{ 'OPEN_TRANSACTION_LIST' | translate }} <i class="fa-solid fa-arrow-right"></i></small>
          </button>
          <button type="button" class="kpi-card kpi-card--info" (click)="openTransactions()">
            <span>{{ 'PENDING_MAPPING' | translate }}</span>
            <strong>{{ dashboard.pendingMapping | number }}</strong>
            <small>{{ 'REQUIRES_MAPPING' | translate }}</small>
          </button>
          <button type="button" class="kpi-card kpi-card--success" (click)="openTransactions()">
            <span>{{ 'READY_FOR_POSTING' | translate }}</span>
            <strong>{{ dashboard.readyForPosting | number }}</strong>
            <small>{{ 'MAPPED_AND_READY' | translate }}</small>
          </button>
          <button type="button" class="kpi-card kpi-card--warning" (click)="openTransactions()">
            <span>{{ 'ON_HOLD' | translate }}</span>
            <strong>{{ dashboard.onHold | number }}</strong>
            <small>{{ 'NEEDS_REVIEW' | translate }}</small>
          </button>
          <button type="button" class="kpi-card kpi-card--danger" (click)="openTransactions()">
            <span>{{ 'EXCEPTIONS' | translate }}</span>
            <strong>{{ dashboard.exceptions | number }}</strong>
            <small>{{ 'ACTION_REQUIRED' | translate }}</small>
          </button>
          <button type="button" class="kpi-card kpi-card--complete" (click)="openTransactions()">
            <span>{{ 'FULLY_POSTED' | translate }}</span>
            <strong>{{ dashboard.fullyPosted | number }}</strong>
            <small>{{ 'COMPLETED' | translate }}</small>
          </button>
        </div>

        <gung-amazon-finance-jobs [compact]="true" (openDetails)="selectSection('jobs')"></gung-amazon-finance-jobs>

        <div class="overview-grid">
          <article class="finance-card">
            <div class="finance-card__header">
              <div>
                <span class="eyebrow">{{ 'AMOUNTS' | translate }}</span>
                <h2>{{ 'TOTALS_BY_CURRENCY' | translate }}</h2>
              </div>
              <i class="fa-solid fa-coins"></i>
            </div>
            @if (dashboard.totalsByCurrency.length) {
              <div class="currency-list">
                @for (total of dashboard.totalsByCurrency; track total.currency) {
                  <div class="currency-row">
                    <div>
                      <strong>{{ total.currency }}</strong
                      ><small>{{ total.transactions | number }} {{ 'TRANSACTIONS_LOWER' | translate }}</small>
                    </div>
                    <span>{{ total.amount | number: '1.2-2' }}</span>
                  </div>
                }
              </div>
            } @else {
              <p class="empty-state">{{ 'NO_FINANCE_DATA' | translate }}</p>
            }
          </article>

          <article class="finance-card">
            <div class="finance-card__header">
              <div>
                <span class="eyebrow">{{ dashboard.missingMappings | number }} {{ 'BLOCKED' | translate }}</span>
                <h2>{{ 'MOST_COMMON_MISSING_MAPPINGS' | translate }}</h2>
              </div>
              <i class="fa-solid fa-triangle-exclamation"></i>
            </div>
            @if (dashboard.mostCommonMissingMappings.length) {
              <div class="mapping-list">
                @for (mapping of dashboard.mostCommonMissingMappings; track mapping.mappingId) {
                  <div class="mapping-row">
                    <code>{{ mapping.mappingId }}</code>
                    <span class="badge text-bg-warning">{{ mapping.transactions | number }}</span>
                  </div>
                }
              </div>
              <button type="button" class="btn btn-link px-0 mt-2" (click)="selectSection('mappings')">
                {{ 'MANAGE_MAPPINGS' | translate }} <i class="fa-solid fa-arrow-right"></i>
              </button>
            } @else {
              <p class="empty-state">
                <i class="fa-solid fa-circle-check text-success"></i> {{ 'NO_MISSING_MAPPINGS' | translate }}
              </p>
            }
          </article>
        </div>
      }
    </section>
  } @else if (activeSection === 'transactions') {
    <gung-amazon-finance-transactions (changed)="loadDashboard()"></gung-amazon-finance-transactions>
  } @else if (activeSection === 'mappings') {
    <gung-amazon-finance-mappings (changed)="loadDashboard()"></gung-amazon-finance-mappings>
  } @else if (activeSection === 'jobs') {
    <gung-amazon-finance-jobs></gung-amazon-finance-jobs>
  } @else if (activeSection === 'configuration') {
    <gung-amazon-finance-configuration></gung-amazon-finance-configuration>
  } @else if (activeErpExtension) {
    <ng-container *ngComponentOutlet="activeErpExtension.configurationComponent"></ng-container>
  }
</main>
